<template>
  <div class="act-options">
    <md-toolbar class="md-primary first-nav">
      <img src="../assets/logo.png" class="logo-navbar" />

      <div class="md-toolbar-section-end nav-style">
        <md-button class="user-mail" @click="logout_active = true">
          <i class="material-icons person-icon">person</i>
        </md-button>
      </div>
    </md-toolbar>

    <div class="md-title second-navbar">COMUNICAZIONE SICURA</div>

    <md-card md-with-hover class="home-card act-opt">
      <md-card-area md-inset>
        <md-card-content>
          <div class="simple-text">
            Il documento è stato inviato correttamente
          </div>
        </md-card-content>
      </md-card-area>

      <md-card-content>
        <md-button
          class="md-raised md-accent"
          v-if="tooHumanitas"
          :to="{ name: 'PatientDownload' }"
          >Torna alla Home
        </md-button>

        <md-button
          class="md-raised md-accent"
          v-if="tooHumanitas"
          :to="{ name: 'RegistrationUploadFile' }"
          >Invia un altro file
        </md-button>
      </md-card-content>
    </md-card>
    <md-dialog-confirm
      :md-active.sync="logout_active"
      md-title="Disconnetti"
      md-content="Cliccando 'Conferma' verrai disconnesso e riportato alla pagina iniziale"
      md-confirm-text="Conferma"
      md-cancel-text="Annulla"
      @md-cancel="logout_active = false"
      @md-confirm="logout()"
    />
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
// @ is an alias to /src
import { LoginChecker } from "@/utils/login-check";

export default {
  name: "act-options",
  data: () => ({
    bottomPosition: "md-bottom-left",
    showLogoutOptions: false,
    user: "",
    tooHumanitas: false,
    logout_active: false
  }),
  mounted: function() {
    this.checkUser();
    this.tooHumanitas = this.$store.state.isToHumanitas;
  },
  methods: {
    logout: function() {
      var self = this;
      firebase
        .auth()
        .signOut()
        .then(function() {
          self.$router.push({ path: "/registration-phone" });
        });
    },
    checkUser: function() {
      var self = this;
      self.tooHumanitas = self.$store.state.isToHumanitas;

      var currentUser = firebase.auth().currentUser;
      if (!currentUser) {
        self.$router.push({
          path: "/"
        });
      } else {
        self.show = true;
        self.user = currentUser.email;
      }
    }
  }
};
</script>

<style scoped>
.logo-navbar {
  text-align: left;
  height: 40px;
}

.logout {
  margin-top: 40px;
}

.home-button {
  width: 487px;
}

.md-card {
  width: 60%;
  margin: 4px;
  display: inline-block;
  vertical-align: center;
}

.nav-style {
  height: 50px;
}

.second-navbar {
  background-color: #027953;
  font-size: 26px;
  font-weight: bold;
  color: #ffffff;
  padding: 1.3%;
}

.title-style {
  color: #027953;
}

.text-card {
  text-align: right;
  color: grey;
}

.act-options {
  min-height: 180px;
}

.md-speed-dial {
  margin: 0 24px 0 8px;
}

.md-card {
  width: 60%;
  margin: 4px;
  display: inline-block;
  vertical-align: center;
}

.act-opt {
  margin-top: 30px;
}

.user-mail {
  background-color: #f2f1f2;
  text-transform: lowercase;
  border-radius: 22px;
}

.user-mail-text {
  float: right;
  padding-top: 3%;
  color: black;
}

.person-icon {
  color: #027953;
}

.simple-text {
  color: black;
  font-size: 17px;
}

.button-text {
  padding-top: 6%;
  padding-left: 1%;
  float: right;
}

.icon-style {
  font-size: 50px;
  background-color: #ea5b0c;
  color: #027953;
  -webkit-border-radius: 22px;
}

.first-nav {
  background-color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/optionsView.vue